export default "__VITE_ASSET__ojM6so06__"